import React from "react";
import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  Stack,
} from "@mui/material";

const OPERATORS = ["=", "!=", "contains", ">", "<", "between", "last_n_days"];

function FilterBuilder({ filters, setFilters, selectableFields }) {
  const addFilter = () => {
    setFilters((prev) => [
      ...prev,
      { field: selectableFields[0] || "", operator: "=", value: "" },
    ]);
  };

  const removeFilter = (idx) => {
    setFilters((prev) => prev.filter((_, i) => i !== idx));
  };

  const updateFilter = (idx, key, value) => {
    setFilters((prev) =>
      prev.map((item, i) => (i === idx ? { ...item, [key]: value } : item))
    );
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="subtitle1" fontWeight={600}>
          Filters
        </Typography>
        <Button size="small" variant="outlined" onClick={addFilter}>
          Add filter
        </Button>
      </Stack>
      {filters.map((item, idx) => (
        <Grid container spacing={2} key={`filter-${idx}`} sx={{ mb: 2 }} alignItems="flex-start">
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth size="small">
              <InputLabel id={`field-${idx}`}>Field</InputLabel>
              <Select
                labelId={`field-${idx}`}
                label="Field"
                value={item.field}
                onChange={(e) => updateFilter(idx, "field", e.target.value)}
              >
                {selectableFields.map((fieldName) => (
                  <MenuItem key={fieldName} value={fieldName}>
                    {fieldName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth size="small">
              <InputLabel id={`op-${idx}`}>Operator</InputLabel>
              <Select
                labelId={`op-${idx}`}
                label="Operator"
                value={item.operator}
                onChange={(e) => updateFilter(idx, "operator", e.target.value)}
              >
                {OPERATORS.map((op) => (
                  <MenuItem key={op} value={op}>
                    {op}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            {item.operator === "between" ? (
              <Stack direction="row" spacing={1}>
                <TextField
                  fullWidth
                  size="small"
                  label="Min"
                  value={Array.isArray(item.value) ? item.value[0] ?? "" : ""}
                  onChange={(e) =>
                    updateFilter(idx, "value", [
                      e.target.value,
                      Array.isArray(item.value) ? item.value[1] : "",
                    ])
                  }
                />
                <TextField
                  fullWidth
                  size="small"
                  label="Max"
                  value={Array.isArray(item.value) ? item.value[1] ?? "" : ""}
                  onChange={(e) =>
                    updateFilter(idx, "value", [
                      Array.isArray(item.value) ? item.value[0] : "",
                      e.target.value,
                    ])
                  }
                />
              </Stack>
            ) : (
              <TextField
                fullWidth
                size="small"
                label={item.operator === "last_n_days" ? "Days" : "Value"}
                value={item.value ?? ""}
                onChange={(e) => updateFilter(idx, "value", e.target.value)}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={1}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              size="small"
              onClick={() => removeFilter(idx)}
              sx={{ minWidth: 48 }}
            >
              ×
            </Button>
          </Grid>
        </Grid>
      ))}
      {filters.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No filters configured.
        </Typography>
      )}
    </Box>
  );
}

export default FilterBuilder;
